import { defineMessages } from 'react-intl';

const messages = defineMessages({
    pageTitle: {
        id:'pageTitleTermsOfService',
        defaultMessage: 'Terms of Service',
        description: 'HTML title for the tos page.',
    },
    pageSubTitle: {
        id:'pageSubTitleTermsOfService',
        defaultMessage: 'Dated: September 23, 2019',
        description: 'Publish date for the tos page.',
    },
});

export default messages;
